import * as React from "react";
import { AuthStore } from "auth/AuthStore";

export function useAuth() {
  return React.useContext(AuthStore);
}
